import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from '@tonic-one/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import ActionNotification from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/ActionNotification';
import ApproveBlockList from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/ApproveBlockList';
import Rules from '@Policy/AdvancedThreatProtection/PolicyTemplate/Filters/WebReputation/Rules';
import { useGlobalSettingStore } from '@Models/useGlobalSettingModel';

const WebReputation = () => {
  const { t } = useTranslation();
  const { selectedOrgGlobalSetting } = useGlobalSettingStore();
  const exOutboundTocFeatureShow =
    !!selectedOrgGlobalSetting?.exOutboundTocFeatureShow;
  return (
    <Box>
      <Tabs>
        <TabList>
          <Tab>{t('policy.rules')}</Tab>
          <Tab>{t('policy.approvedAndBlockedList')}</Tab>
          <Tab>{t('policy.actionAndNotification')}</Tab>
        </TabList>
        <TabPanels py="2x">
          <TabPanel>
            <Rules
              applyBoundShow={false}
              retroScanShow={false}
              timeOfClickShow={exOutboundTocFeatureShow}
              detectionTequeniquesShow={true}
            />
          </TabPanel>
          <TabPanel>
            <ApproveBlockList />
          </TabPanel>
          <TabPanel>
            <ActionNotification />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};
export default React.memo(WebReputation);
